export default "__VITE_ASSET__Dhd0mCdE__"